export abstract class AbstractError extends Error {
  constructor(message?: string) {
    super(message)

    //@ts-expect-error("line found from previous coders")
    this.__proto__ = new.target.prototype
  }
}
